export const environment = {
  production: false,
  csibefrontend: "https://focus-dev.roarinc.it/csibefrontend/",
  // @ts-ignore
  csionlinereputationmax_tenant: "stellantis",
  csionlinereputationmax_google: "google",
  assets: "assets/",
  featureFlags: {
    ssoManagement: true,
    ssoHarmonization: true,
    maintenanceBanner: false
  }

};

